<template>
    <div id="app">
        <transition name="fade">
            <router-view></router-view>
        </transition>
        <!--
        <router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in">
                <component :is="Component" />
            </transition>
        </router-view>
        -->
    </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

body, p, a, div, span {
    font-family: monospace;
}

a {
    text-decoration: none;
    color: #fff;
}

.flex-container {
    display: flex;
}

.pa-big {
    padding: 24pt 10pt;
}

.wisdom {
    padding: 0.65em 0.1em;
    font-size: 5vw;
    text-align: center;
}


.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s ease;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

#app, #container, html, body {
    height: 100%;
}

#container {
    display: flex;
    align-items: stretch;
}

aside img {
    height: 100%;
}

.ptr {
    cursor: pointer;
}

body {
    margin: 0;
    padding: 0;
    font-family: sans-serif;
    background: #000;
    color: #fff;
}

main {
    flex: 1;
}

footer {
    text-align: center;
}

.align-center {
    text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/App.vue